let Api = {
  "PROTAL_ABOUT_LIST": "/dc/n/protal/about/list", //关于我们
  "STANDARD_FINDCOUNT": "/standard/n/app/findStandarMageCount", //标准列表
  "XLZB_FINDCOUNT": "/standard/xlzb/findXlzbCount", //标准列表
  "REPLENISH_FINDCOUNT": "/dc/replenish/selGeoCount", //地理标志产品
  "MTYX_FINDCOUNT": "/dc/replenish/selMtyxCount", //名特优新数量
  "SAMPLE_FINDCOUNT": "/dc/replenish/sampleCount", //样品数
  "OVERVIEW_FINDCOUNT": "/dc/replenish/overview", //品质特征数
  "THREEPLUSONE_FINDLIST": "/trace/n/threePlusOne/findList", //三加一首页列表查询
  "THREEPLUSONE_GETDETAIL": "/trace/n/threePlusOne/getDetail", //三加一首页信息
  "THREEPLUSONE_SAVE": "/trace/n/threePlusOne/save", //三加一首页-保存信息


  "PROTAL_N_INDUSTRYFRIENDLY_FINDLIST": "/portal-api/n/IndustryFriendlyLinkManage/findList", //友情链接
  "PROTAL_N_INDUSTRYMODULE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", // 关于我们
  "PROTAL_N_PROTOCOL_GETPROTOCOLINFO": "/portal-api/n/protocol/getProtocolInfo", // 协议配置
  "PROTAL_N_INDUSTRYCERTIFICATION_FINDLIST_TYPE": "/portal-api/n/IndustryCertification/findList", // 商务资质/公司主体
  "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE": "/portal-api/n/IndustryMange/findDefaultByType", // 基础信息
  
}
module.exports = Api